import axios from "axios";
const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const apiClient = axios.create({ baseURL: API });
